import React, { PropsWithChildren } from "react";
import cn from "classnames";
/**
 * The details component of a section, to be used inside the header.
 */
/**
 * @deprecated
 */
export const SectionDetails: React.FC<PropsWithChildren<{}>> = ({ children }: PropsWithChildren<{}>) => {
  const className = cn("section-details");
  return <div className={className}>{children}</div>;
};
